// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__TfyWU","approved":"Status_approved__1ye1u","rejected":"Status_rejected__3z49G","expired":"Status_expired__2nUfn","label":"Status_label__r6qeP"};